import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { ConversionSuiteStatusesContext } from "../../redo-suite/conversion-cloud";
import { useScheduleDemo } from "../common/schedule-demo-provider";

/**
 * Returns whether a feature is locked for the current team and a click handler
 * that opens the schedule-a-call flow for the given surface. Used by sidebar
 * nav items and dashboard upsell cards in the intent-only state.
 *
 * Routes through the shared schedule-demo flow: Redo employees get the
 * order-counts modal, everyone else notifies the CRO squad and is sent to
 * HubSpot.
 */
export function useConversionLockedAction(
  buttonLocation: ScheduleDemoButtonLocation,
) {
  const { accessLevel } = useRequiredContext(ConversionSuiteStatusesContext);
  const { handleScheduleDemo } = useScheduleDemo();

  const locked = accessLevel === "intent-only";

  const onLockedClick = useHandler(async () => {
    await handleScheduleDemo({ buttonLocation });
  });

  return { locked, onLockedClick };
}
